/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AggregatedCurveFilter } from '../model/aggregatedCurveFilter';
// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { ReportMetadata } from '../model/reportMetadata';
// @ts-ignore
import { TrackFileRequest } from '../model/trackFileRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface AccountReportRequestParams {
  businessEntity?: 'SANDBOX1' | 'SANDBOX2' | 'INC' | 'BERMUDA' | 'BRAZIL';
}

export interface AdminReportRequestParams {
  /** Include Account IDs for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Exclude Account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Include Pair IDs for filtering. Can be filled if \&#39;excludePairIds\&#39; is empty. */
  pairId?: Array<number>;
  /** Exclude Pair IDs for filtering. Can be filled if \&#39;pairId\&#39; is empty. */
  excludePairIds?: Array<number>;
  /** Order statuses for filtering */
  orderStatus?: Array<
    'ACTIVE' | 'CANCELED' | 'FILLED' | 'PARTIALLY_FILLED' | 'PARTIALLY_FILLED_CANCELED' | 'REJECTED' | 'WAITING_TRIGGER'
  >;
  /** If true - exclude account House. */
  excludeHouseLp?: boolean;
  /** If true - filled quantity exists. */
  existFilledQty?: boolean;
  /** Jurisdiction for filtering. */
  jurisdiction?: string;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface AgentReportRequestParams {
  /** Agent ID for filtering */
  agentId: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface AnalyticsCurveCsvReportRequestParams {
  aggregatedCurveFilter: AggregatedCurveFilter;
}

export interface BalanceReportRequestParams {
  businessEntity?: 'SANDBOX1' | 'SANDBOX2' | 'INC' | 'BERMUDA' | 'BRAZIL';
  /** Point in time, rounding down with 1 hour step */
  pointInTime?: string;
  /** True - means exclude \&#39;Internal\&#39; accounts. */
  excludeInternalAccounts?: boolean;
}

export interface BookHistoryReportRequestParams {
  /** Pair IDs. */
  pairIds: Array<number>;
  /** Step in milliseconds. 100 ms by default */
  stepTime: number;
  /** Depth of book. Must be &gt; 0 and &lt;&#x3D; 10. */
  depth: number;
  /** From time for filtering, inclusive */
  fromTime: string;
  /** To time for filtering, inclusive */
  toTime: string;
}

export interface CancelRequestParams {
  id: number;
}

export interface ClientReportRequestParams {
  /** Account ID for filtering */
  accountId?: number;
  /** Include pair IDs for filtering. Can be filled if \&#39;excludePairIds\&#39; is empty. */
  pairId?: Array<number>;
  /** Exclude Pair IDs for filtering. Can be filled if \&#39;pairId\&#39; is empty. */
  excludePairIds?: Array<number>;
  /** Jurisdiction for filtering */
  jurisdiction?: string;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface ComprehensiveCsvReportRequestParams {
  /** Account ID for filtering */
  accountId: number;
  /** From time for filtering, inclusive */
  fromTime: string;
  /** To time for filtering, inclusive */
  toTime: string;
  /** Custom time zone */
  customZone?: string;
  /** Specific order statuses */
  orderStatuses?: Array<
    'ACTIVE' | 'CANCELED' | 'FILLED' | 'PARTIALLY_FILLED' | 'PARTIALLY_FILLED_CANCELED' | 'REJECTED' | 'WAITING_TRIGGER'
  >;
  /** Specific transfer statuses */
  transferStatuses?: Array<'PENDING' | 'ERROR' | 'SETTLED'>;
}

export interface ComprehensivePdfReportRequestParams {
  /** Account ID for filtering */
  accountId: number;
  /** From time for filtering, inclusive */
  fromTime: string;
  /** To time for filtering, inclusive */
  toTime: string;
  /** Custom time zone */
  customZone?: string;
  /** Specific order statuses */
  orderStatuses?: Array<
    'ACTIVE' | 'CANCELED' | 'FILLED' | 'PARTIALLY_FILLED' | 'PARTIALLY_FILLED_CANCELED' | 'REJECTED' | 'WAITING_TRIGGER'
  >;
  /** Specific transfer statuses */
  transferStatuses?: Array<'PENDING' | 'ERROR' | 'SETTLED'>;
}

export interface DownloadReportRequestParams {
  id: number;
}

export interface DownloadTrackFileRequestParams {
  trackFileRequest: TrackFileRequest;
}

export interface ExternalTradesReportRequestParams {
  /** Market making platform id */
  marketMakingPlatformId: number;
  /** Include Pair IDs for filtering. Can be filled if \&#39;excludePairIds\&#39; is empty. */
  pairIds?: Array<number>;
  /** Exclude Pair IDs for filtering. Can be filled if \&#39;pairIds\&#39; is empty. */
  excludePairIds?: Array<number>;
  /** Custom time zone */
  customZone?: string;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
}

export interface GetReportMetadataRequestParams {
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** User ID for filtering */
  userId?: number;
  /** Account ID for filtering */
  accountId?: number;
}

export interface GetReportMetadataByIdRequestParams {
  id: number;
}

export interface GoldenTransferReportRequestParams {
  /** Included Client account IDs for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountIds?: Array<number>;
  /** Excluded Client account IDs for filtering. Can be filled if \&#39;accountIds\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Included asset IDs for filtering. Can be filled if \&#39;excludedAssetIds\&#39; is empty. */
  assetIds?: Array<number>;
  /** Excluded asset IDs for filtering. Can be filled if \&#39;assetIds\&#39; is empty. */
  excludeAssetIds?: Array<number>;
  /** Included request Admin IDs for filtering. Can be filled if \&#39;excludeRequestAdminIds\&#39; is empty. */
  requestAdminIds?: Array<number>;
  /** Excluded request Admin IDs for filtering. Can be filled if \&#39;requestAdminIds\&#39; is empty. */
  excludeRequestAdminIds?: Array<number>;
  /** Included approve Admin IDs for filtering. Can be filled if \&#39;excludeApproveAdminIds\&#39; is empty. */
  approveAdminIds?: Array<number>;
  /** Excluded approve Admin IDs for filtering. Can be filled if \&#39;approveAdminIds\&#39; is empty. */
  excludeApproveAdminIds?: Array<number>;
  direction?: 'DEPOSIT' | 'WITHDRAW' | 'INTERNAL' | 'DEPOSIT_REBATE' | 'WITHDRAW_REBATE';
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface HouseLpTradeReportRequestParams {
  /** Pair ID for filtering */
  pairId?: number;
  /** Counterparty type for filtering */
  counterpartyType?: 'ACCOUNT' | 'LIQUIDITY_PROVIDER';
  /** Counterparty ID for filtering */
  counterpartyId?: number;
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface LpTradesReportRequestParams {
  /** Included Client account ID for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Excluded Client account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Included Liquidity provider ID for filtering. Can be filled if \&#39;excludedLpIds\&#39; is empty. */
  lpId?: Array<number>;
  /** Excluded Liquidity provider ID for filtering. Can be filled if \&#39;lpId\&#39; is empty. */
  excludedLpIds?: Array<number>;
  /** If true - Show all order. Corrected orders as well. */
  canceled?: boolean;
  /** If true - Show orders with zero executed qty. */
  zeroExecutedQty?: boolean;
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface PerpPositionHistoryReportRequestParams {
  /** From time for filtering, inclusive */
  fromTime: string;
  /** To time for filtering, inclusive */
  toTime: string;
  /** Perpetual pair IDs */
  perpPairIds?: Array<number>;
}

export interface RfqReportRequestParams {
  /** Include Account IDs for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Exclude Account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Include Pair IDs for filtering. Can be filled if \&#39;excludePairIds\&#39; is empty. */
  pairId?: Array<number>;
  /** Exclude Pair IDs for filtering. Can be filled if \&#39;pairId\&#39; is empty. */
  excludePairIds?: Array<number>;
  /** Show only activated RFQs */
  onlyActivated?: boolean;
  /** Rfq type for filtering */
  rfqType?: Array<'FIVE_SECONDS' | 'THIRTY_SECONDS' | 'ONE_SECOND' | 'EIGHT_SECONDS'>;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface SpotPositionHistoryReportRequestParams {
  /** From time for filtering, inclusive */
  fromTime: string;
  /** To time for filtering, inclusive */
  toTime: string;
  /** Asset IDs */
  assetIds?: Array<number>;
}

export interface SystemLogReportRequestParams {
  /** Reporting code ids for filtering */
  reportingCodeIds?: Array<number>;
  /** Include Account IDs for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Exclude Account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Include User IDs for filtering. Can be filled if \&#39;excludeUserIds\&#39; is empty. */
  userId?: Array<number>;
  /** Exclude User IDs for filtering. Can be filled if \&#39;userId\&#39; is empty. */
  excludeUserIds?: Array<number>;
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface TopOfBookHistoryReportRequestParams {
  /** Top of book source IDs. */
  topOfBookSourceIds: Array<number>;
  /** Step in milliseconds. 100 ms by default */
  stepTime: number;
  /** From time for filtering, inclusive */
  fromTime: string;
  /** To time for filtering, inclusive */
  toTime: string;
}

export interface TradeConfirmationReportRequestParams {
  orderId: number;
  /** Custom time zone */
  customZone?: string;
}

export interface TransactionLogReportRequestParams {
  /** Account ID for filtering */
  accountId?: number;
  /** Asset ID for filtering */
  assetId?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface TransferReportRequestParams {
  /** Included Client account ID for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Excluded Client account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Included asset IDs for filtering. Can be filled if \&#39;excludedAssetIds\&#39; is empty. */
  assetId?: Array<number>;
  /** Excluded asset IDs for filtering. Can be filled if \&#39;assetId\&#39; is empty. */
  excludedAssetIds?: Array<number>;
  /** Transfer sources */
  source?: Array<'MANUAL' | 'FIREBLOCKS' | 'GOLDEN' | 'EXCHANGE_TO_EXCHANGE' | 'HRP_SETTLEMENT'>;
  /** Transfer statuses */
  status?: Array<'PENDING' | 'ERROR' | 'SETTLED'>;
  /** Jurisdiction for filtering */
  jurisdiction?: string;
  /** Business Entity for filtering */
  businessEntity?: 'SANDBOX1' | 'SANDBOX2' | 'INC' | 'BERMUDA' | 'BRAZIL';
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface TsoeFixReportRequestParams {
  /** From time for filtering, inclusive */
  fromTime: string;
  /** To time for filtering, inclusive */
  toTime: string;
  /** Spot pair IDs */
  spotPairIds?: Array<number>;
  /** Perpetual pair IDs */
  perpPairIds?: Array<number>;
  /** Exchange name */
  exchangeName?: string;
}

export interface UserSessionReportRequestParams {
  /** Include Account IDs for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Exclude Account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Include User IDs for filtering. Can be filled if \&#39;excludeUserIds\&#39; is empty. */
  userId?: Array<number>;
  /** Exclude User IDs for filtering. Can be filled if \&#39;userId\&#39; is empty. */
  excludeUserIds?: Array<number>;
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface ZeroHashClobReportRequestParams {
  /** Include Pair IDs for filtering. Can be filled if \&#39;excludePairIds\&#39; is empty. */
  pairId?: Array<number>;
  /** Exclude Pair IDs for filtering. Can be filled if \&#39;pairId\&#39; is empty. */
  excludePairIds?: Array<number>;
  /** Custom time zone */
  customZone?: string;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ReportingControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Requests account file
   * @endpoint get /v1/reporting/account
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public accountReport(
    requestParameters?: AccountReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public accountReport(
    requestParameters?: AccountReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public accountReport(
    requestParameters?: AccountReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public accountReport(
    requestParameters?: AccountReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const businessEntity = requestParameters?.businessEntity;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'businessEntity',
      <any>businessEntity,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/account`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests admin order history file
   * @endpoint get /v1/reporting/admin
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public adminReport(
    requestParameters?: AdminReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public adminReport(
    requestParameters?: AdminReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public adminReport(
    requestParameters?: AdminReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public adminReport(
    requestParameters?: AdminReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const pairId = requestParameters?.pairId;
    const excludePairIds = requestParameters?.excludePairIds;
    const orderStatus = requestParameters?.orderStatus;
    const excludeHouseLp = requestParameters?.excludeHouseLp;
    const existFilledQty = requestParameters?.existFilledQty;
    const jurisdiction = requestParameters?.jurisdiction;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairId',
      <any>pairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludePairIds',
      <any>excludePairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'orderStatus',
      <any>orderStatus,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeHouseLp',
      <any>excludeHouseLp,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'existFilledQty',
      <any>existFilledQty,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'jurisdiction',
      <any>jurisdiction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/admin`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Download agent report
   * @endpoint get /v1/reporting/agent
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public agentReport(
    requestParameters: AgentReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'text/csv'; context?: HttpContext },
  ): Observable<Blob>;
  public agentReport(
    requestParameters: AgentReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'text/csv'; context?: HttpContext },
  ): Observable<HttpResponse<Blob>>;
  public agentReport(
    requestParameters: AgentReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'text/csv'; context?: HttpContext },
  ): Observable<HttpEvent<Blob>>;
  public agentReport(
    requestParameters: AgentReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | 'text/csv'; context?: HttpContext },
  ): Observable<any> {
    const agentId = requestParameters?.agentId;
    if (agentId === null || agentId === undefined) {
      throw new Error('Required parameter agentId was null or undefined when calling agentReport.');
    }
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'agentId',
      <any>agentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', 'text/csv']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let localVarPath = `/v1/reporting/agent`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: 'blob',
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests comprehensive history file
   * @endpoint post /v1/reporting/analytics-curve-csv
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public analyticsCurveCsvReport(
    requestParameters: AnalyticsCurveCsvReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public analyticsCurveCsvReport(
    requestParameters: AnalyticsCurveCsvReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public analyticsCurveCsvReport(
    requestParameters: AnalyticsCurveCsvReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public analyticsCurveCsvReport(
    requestParameters: AnalyticsCurveCsvReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const aggregatedCurveFilter = requestParameters?.aggregatedCurveFilter;
    if (aggregatedCurveFilter === null || aggregatedCurveFilter === undefined) {
      throw new Error(
        'Required parameter aggregatedCurveFilter was null or undefined when calling analyticsCurveCsvReport.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/analytics-curve-csv`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: aggregatedCurveFilter,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Download balances
   * @endpoint get /v1/reporting/balances
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public balanceReport(
    requestParameters?: BalanceReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'text/csv'; context?: HttpContext },
  ): Observable<Blob>;
  public balanceReport(
    requestParameters?: BalanceReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'text/csv'; context?: HttpContext },
  ): Observable<HttpResponse<Blob>>;
  public balanceReport(
    requestParameters?: BalanceReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'text/csv'; context?: HttpContext },
  ): Observable<HttpEvent<Blob>>;
  public balanceReport(
    requestParameters?: BalanceReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | 'text/csv'; context?: HttpContext },
  ): Observable<any> {
    const businessEntity = requestParameters?.businessEntity;
    const pointInTime = requestParameters?.pointInTime;
    const excludeInternalAccounts = requestParameters?.excludeInternalAccounts;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'businessEntity',
      <any>businessEntity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pointInTime',
      <any>pointInTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeInternalAccounts',
      <any>excludeInternalAccounts,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', 'text/csv']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let localVarPath = `/v1/reporting/balances`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: 'blob',
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests book history file
   * @endpoint get /v1/reporting/book
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public bookHistoryReport(
    requestParameters: BookHistoryReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public bookHistoryReport(
    requestParameters: BookHistoryReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public bookHistoryReport(
    requestParameters: BookHistoryReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public bookHistoryReport(
    requestParameters: BookHistoryReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const pairIds = requestParameters?.pairIds;
    if (pairIds === null || pairIds === undefined) {
      throw new Error('Required parameter pairIds was null or undefined when calling bookHistoryReport.');
    }
    const stepTime = requestParameters?.stepTime;
    if (stepTime === null || stepTime === undefined) {
      throw new Error('Required parameter stepTime was null or undefined when calling bookHistoryReport.');
    }
    const depth = requestParameters?.depth;
    if (depth === null || depth === undefined) {
      throw new Error('Required parameter depth was null or undefined when calling bookHistoryReport.');
    }
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling bookHistoryReport.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling bookHistoryReport.');
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairIds',
      <any>pairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'stepTime',
      <any>stepTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'depth',
      <any>depth,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/book`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Cancels process of creation and downloading report
   * @endpoint post /v1/reporting/cancel/{id}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public cancel(
    requestParameters: CancelRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any>;
  public cancel(
    requestParameters: CancelRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<any>>;
  public cancel(
    requestParameters: CancelRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<any>>;
  public cancel(
    requestParameters: CancelRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling cancel.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/cancel/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests client order history file
   * @endpoint get /v1/reporting/client
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public clientReport(
    requestParameters?: ClientReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public clientReport(
    requestParameters?: ClientReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public clientReport(
    requestParameters?: ClientReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public clientReport(
    requestParameters?: ClientReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const pairId = requestParameters?.pairId;
    const excludePairIds = requestParameters?.excludePairIds;
    const jurisdiction = requestParameters?.jurisdiction;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairId',
      <any>pairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludePairIds',
      <any>excludePairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'jurisdiction',
      <any>jurisdiction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/client`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests comprehensive history file
   * @endpoint get /v1/reporting/comprehensive_csv
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public comprehensiveCsvReport(
    requestParameters: ComprehensiveCsvReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public comprehensiveCsvReport(
    requestParameters: ComprehensiveCsvReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public comprehensiveCsvReport(
    requestParameters: ComprehensiveCsvReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public comprehensiveCsvReport(
    requestParameters: ComprehensiveCsvReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    if (accountId === null || accountId === undefined) {
      throw new Error('Required parameter accountId was null or undefined when calling comprehensiveCsvReport.');
    }
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling comprehensiveCsvReport.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling comprehensiveCsvReport.');
    }
    const customZone = requestParameters?.customZone;
    const orderStatuses = requestParameters?.orderStatuses;
    const transferStatuses = requestParameters?.transferStatuses;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'orderStatuses',
      <any>orderStatuses,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'transferStatuses',
      <any>transferStatuses,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/comprehensive_csv`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests comprehensive history file
   * @endpoint get /v1/reporting/comprehensive_pdf
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public comprehensivePdfReport(
    requestParameters: ComprehensivePdfReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public comprehensivePdfReport(
    requestParameters: ComprehensivePdfReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public comprehensivePdfReport(
    requestParameters: ComprehensivePdfReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public comprehensivePdfReport(
    requestParameters: ComprehensivePdfReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    if (accountId === null || accountId === undefined) {
      throw new Error('Required parameter accountId was null or undefined when calling comprehensivePdfReport.');
    }
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling comprehensivePdfReport.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling comprehensivePdfReport.');
    }
    const customZone = requestParameters?.customZone;
    const orderStatuses = requestParameters?.orderStatuses;
    const transferStatuses = requestParameters?.transferStatuses;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'orderStatuses',
      <any>orderStatuses,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'transferStatuses',
      <any>transferStatuses,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/comprehensive_pdf`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Download report
   * @endpoint get /v1/reporting/download/{id}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public downloadReport(
    requestParameters: DownloadReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<Blob>;
  public downloadReport(
    requestParameters: DownloadReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpResponse<Blob>>;
  public downloadReport(
    requestParameters: DownloadReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpEvent<Blob>>;
  public downloadReport(
    requestParameters: DownloadReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling downloadReport.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let localVarPath = `/v1/reporting/download/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: 'blob',
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Download track file
   * @endpoint post /v1/tracking/top-of-book
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public downloadTrackFile(
    requestParameters: DownloadTrackFileRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<Blob>;
  public downloadTrackFile(
    requestParameters: DownloadTrackFileRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpResponse<Blob>>;
  public downloadTrackFile(
    requestParameters: DownloadTrackFileRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpEvent<Blob>>;
  public downloadTrackFile(
    requestParameters: DownloadTrackFileRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<any> {
    const trackFileRequest = requestParameters?.trackFileRequest;
    if (trackFileRequest === null || trackFileRequest === undefined) {
      throw new Error('Required parameter trackFileRequest was null or undefined when calling downloadTrackFile.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let localVarPath = `/v1/tracking/top-of-book`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: trackFileRequest,
      responseType: 'blob',
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * External trade history file
   * @endpoint get /v1/reporting/external-trades
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public externalTradesReport(
    requestParameters: ExternalTradesReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public externalTradesReport(
    requestParameters: ExternalTradesReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public externalTradesReport(
    requestParameters: ExternalTradesReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public externalTradesReport(
    requestParameters: ExternalTradesReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const marketMakingPlatformId = requestParameters?.marketMakingPlatformId;
    if (marketMakingPlatformId === null || marketMakingPlatformId === undefined) {
      throw new Error(
        'Required parameter marketMakingPlatformId was null or undefined when calling externalTradesReport.',
      );
    }
    const pairIds = requestParameters?.pairIds;
    const excludePairIds = requestParameters?.excludePairIds;
    const customZone = requestParameters?.customZone;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairIds',
      <any>pairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludePairIds',
      <any>excludePairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'marketMakingPlatformId',
      <any>marketMakingPlatformId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/external-trades`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets ReportMetadata(up to 100)
   * @endpoint get /v1/reporting
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getReportMetadata(
    requestParameters?: GetReportMetadataRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<ReportMetadata>>;
  public getReportMetadata(
    requestParameters?: GetReportMetadataRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<ReportMetadata>>>;
  public getReportMetadata(
    requestParameters?: GetReportMetadataRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<ReportMetadata>>>;
  public getReportMetadata(
    requestParameters?: GetReportMetadataRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const userId = requestParameters?.userId;
    const accountId = requestParameters?.accountId;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'userId',
      <any>userId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<ReportMetadata>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets report metadata by id
   * @endpoint post /v1/reporting/{id}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getReportMetadataById(
    requestParameters: GetReportMetadataByIdRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public getReportMetadataById(
    requestParameters: GetReportMetadataByIdRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public getReportMetadataById(
    requestParameters: GetReportMetadataByIdRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public getReportMetadataById(
    requestParameters: GetReportMetadataByIdRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getReportMetadataById.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests golden transfer history file
   * @endpoint get /v1/reporting/golden-transfer
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public goldenTransferReport(
    requestParameters?: GoldenTransferReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public goldenTransferReport(
    requestParameters?: GoldenTransferReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public goldenTransferReport(
    requestParameters?: GoldenTransferReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public goldenTransferReport(
    requestParameters?: GoldenTransferReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountIds = requestParameters?.accountIds;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const assetIds = requestParameters?.assetIds;
    const excludeAssetIds = requestParameters?.excludeAssetIds;
    const requestAdminIds = requestParameters?.requestAdminIds;
    const excludeRequestAdminIds = requestParameters?.excludeRequestAdminIds;
    const approveAdminIds = requestParameters?.approveAdminIds;
    const excludeApproveAdminIds = requestParameters?.excludeApproveAdminIds;
    const direction = requestParameters?.direction;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountIds',
      <any>accountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'assetIds',
      <any>assetIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAssetIds',
      <any>excludeAssetIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'requestAdminIds',
      <any>requestAdminIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeRequestAdminIds',
      <any>excludeRequestAdminIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'approveAdminIds',
      <any>approveAdminIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeApproveAdminIds',
      <any>excludeApproveAdminIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'direction',
      <any>direction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/golden-transfer`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests House Lp trades history file
   * @endpoint get /v1/reporting/house-lp-trade
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public houseLpTradeReport(
    requestParameters?: HouseLpTradeReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public houseLpTradeReport(
    requestParameters?: HouseLpTradeReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public houseLpTradeReport(
    requestParameters?: HouseLpTradeReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public houseLpTradeReport(
    requestParameters?: HouseLpTradeReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const pairId = requestParameters?.pairId;
    const counterpartyType = requestParameters?.counterpartyType;
    const counterpartyId = requestParameters?.counterpartyId;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairId',
      <any>pairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'counterpartyType',
      <any>counterpartyType,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'counterpartyId',
      <any>counterpartyId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/house-lp-trade`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests lp trades history file
   * @endpoint get /v1/reporting/lp-trades
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public lpTradesReport(
    requestParameters?: LpTradesReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public lpTradesReport(
    requestParameters?: LpTradesReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public lpTradesReport(
    requestParameters?: LpTradesReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public lpTradesReport(
    requestParameters?: LpTradesReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const lpId = requestParameters?.lpId;
    const excludedLpIds = requestParameters?.excludedLpIds;
    const canceled = requestParameters?.canceled;
    const zeroExecutedQty = requestParameters?.zeroExecutedQty;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'lpId',
      <any>lpId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludedLpIds',
      <any>excludedLpIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'canceled',
      <any>canceled,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'zeroExecutedQty',
      <any>zeroExecutedQty,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/lp-trades`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests Perpetual position history report file
   * @endpoint get /v1/reporting/perp-position-history
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public perpPositionHistoryReport(
    requestParameters: PerpPositionHistoryReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public perpPositionHistoryReport(
    requestParameters: PerpPositionHistoryReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public perpPositionHistoryReport(
    requestParameters: PerpPositionHistoryReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public perpPositionHistoryReport(
    requestParameters: PerpPositionHistoryReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling perpPositionHistoryReport.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling perpPositionHistoryReport.');
    }
    const perpPairIds = requestParameters?.perpPairIds;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'perpPairIds',
      <any>perpPairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/perp-position-history`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests rfq history file
   * @endpoint get /v1/reporting/rfq
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public rfqReport(
    requestParameters?: RfqReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public rfqReport(
    requestParameters?: RfqReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public rfqReport(
    requestParameters?: RfqReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public rfqReport(
    requestParameters?: RfqReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const pairId = requestParameters?.pairId;
    const excludePairIds = requestParameters?.excludePairIds;
    const onlyActivated = requestParameters?.onlyActivated;
    const rfqType = requestParameters?.rfqType;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairId',
      <any>pairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludePairIds',
      <any>excludePairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'onlyActivated',
      <any>onlyActivated,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'rfqType',
      <any>rfqType,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/rfq`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests Spot position history report file
   * @endpoint get /v1/reporting/spot-position-history
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public spotPositionHistoryReport(
    requestParameters: SpotPositionHistoryReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public spotPositionHistoryReport(
    requestParameters: SpotPositionHistoryReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public spotPositionHistoryReport(
    requestParameters: SpotPositionHistoryReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public spotPositionHistoryReport(
    requestParameters: SpotPositionHistoryReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling spotPositionHistoryReport.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling spotPositionHistoryReport.');
    }
    const assetIds = requestParameters?.assetIds;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'assetIds',
      <any>assetIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/spot-position-history`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests system log history file
   * @endpoint get /v1/reporting/system-log
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public systemLogReport(
    requestParameters?: SystemLogReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public systemLogReport(
    requestParameters?: SystemLogReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public systemLogReport(
    requestParameters?: SystemLogReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public systemLogReport(
    requestParameters?: SystemLogReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const reportingCodeIds = requestParameters?.reportingCodeIds;
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const userId = requestParameters?.userId;
    const excludeUserIds = requestParameters?.excludeUserIds;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'reportingCodeIds',
      <any>reportingCodeIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'userId',
      <any>userId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeUserIds',
      <any>excludeUserIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/system-log`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests top of book history file
   * @endpoint get /v1/reporting/top-of-book-history
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public topOfBookHistoryReport(
    requestParameters: TopOfBookHistoryReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public topOfBookHistoryReport(
    requestParameters: TopOfBookHistoryReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public topOfBookHistoryReport(
    requestParameters: TopOfBookHistoryReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public topOfBookHistoryReport(
    requestParameters: TopOfBookHistoryReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const topOfBookSourceIds = requestParameters?.topOfBookSourceIds;
    if (topOfBookSourceIds === null || topOfBookSourceIds === undefined) {
      throw new Error(
        'Required parameter topOfBookSourceIds was null or undefined when calling topOfBookHistoryReport.',
      );
    }
    const stepTime = requestParameters?.stepTime;
    if (stepTime === null || stepTime === undefined) {
      throw new Error('Required parameter stepTime was null or undefined when calling topOfBookHistoryReport.');
    }
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling topOfBookHistoryReport.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling topOfBookHistoryReport.');
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'topOfBookSourceIds',
      <any>topOfBookSourceIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'stepTime',
      <any>stepTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/top-of-book-history`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Download trade confirmation file
   * @endpoint get /v1/reporting/trade-confirmation/{orderId}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public tradeConfirmationReport(
    requestParameters: TradeConfirmationReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'application/pdf'; context?: HttpContext },
  ): Observable<Blob>;
  public tradeConfirmationReport(
    requestParameters: TradeConfirmationReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'application/pdf'; context?: HttpContext },
  ): Observable<HttpResponse<Blob>>;
  public tradeConfirmationReport(
    requestParameters: TradeConfirmationReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | 'application/pdf'; context?: HttpContext },
  ): Observable<HttpEvent<Blob>>;
  public tradeConfirmationReport(
    requestParameters: TradeConfirmationReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | 'application/pdf'; context?: HttpContext },
  ): Observable<any> {
    const orderId = requestParameters?.orderId;
    if (orderId === null || orderId === undefined) {
      throw new Error('Required parameter orderId was null or undefined when calling tradeConfirmationReport.');
    }
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', 'application/pdf']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let localVarPath = `/v1/reporting/trade-confirmation/${this.configuration.encodeParam({ name: 'orderId', value: orderId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: 'blob',
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests transaction log history file
   * @endpoint get /v1/reporting/transaction-log
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public transactionLogReport(
    requestParameters?: TransactionLogReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public transactionLogReport(
    requestParameters?: TransactionLogReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public transactionLogReport(
    requestParameters?: TransactionLogReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public transactionLogReport(
    requestParameters?: TransactionLogReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const assetId = requestParameters?.assetId;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'assetId',
      <any>assetId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/transaction-log`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests transfer history file
   * @endpoint get /v1/reporting/report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public transferReport(
    requestParameters?: TransferReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public transferReport(
    requestParameters?: TransferReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public transferReport(
    requestParameters?: TransferReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public transferReport(
    requestParameters?: TransferReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const assetId = requestParameters?.assetId;
    const excludedAssetIds = requestParameters?.excludedAssetIds;
    const source = requestParameters?.source;
    const status = requestParameters?.status;
    const jurisdiction = requestParameters?.jurisdiction;
    const businessEntity = requestParameters?.businessEntity;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'assetId',
      <any>assetId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludedAssetIds',
      <any>excludedAssetIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'source',
      <any>source,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'status',
      <any>status,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'jurisdiction',
      <any>jurisdiction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'businessEntity',
      <any>businessEntity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/report`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests TSOE FIX report file
   * @endpoint get /v1/reporting/tsoe-fix-events
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public tsoeFixReport(
    requestParameters: TsoeFixReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public tsoeFixReport(
    requestParameters: TsoeFixReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public tsoeFixReport(
    requestParameters: TsoeFixReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public tsoeFixReport(
    requestParameters: TsoeFixReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling tsoeFixReport.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling tsoeFixReport.');
    }
    const spotPairIds = requestParameters?.spotPairIds;
    const perpPairIds = requestParameters?.perpPairIds;
    const exchangeName = requestParameters?.exchangeName;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'spotPairIds',
      <any>spotPairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'perpPairIds',
      <any>perpPairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'exchangeName',
      <any>exchangeName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/tsoe-fix-events`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests user session history file
   * @endpoint get /v1/reporting/user-sessions
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public userSessionReport(
    requestParameters?: UserSessionReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public userSessionReport(
    requestParameters?: UserSessionReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public userSessionReport(
    requestParameters?: UserSessionReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public userSessionReport(
    requestParameters?: UserSessionReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const userId = requestParameters?.userId;
    const excludeUserIds = requestParameters?.excludeUserIds;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'userId',
      <any>userId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeUserIds',
      <any>excludeUserIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/user-sessions`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Zero hash clob external trade history file
   * @endpoint get /v1/reporting/zero-hash-clob-external-rade
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public zeroHashClobReport(
    requestParameters?: ZeroHashClobReportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<ReportMetadata>;
  public zeroHashClobReport(
    requestParameters?: ZeroHashClobReportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<ReportMetadata>>;
  public zeroHashClobReport(
    requestParameters?: ZeroHashClobReportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<ReportMetadata>>;
  public zeroHashClobReport(
    requestParameters?: ZeroHashClobReportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const pairId = requestParameters?.pairId;
    const excludePairIds = requestParameters?.excludePairIds;
    const customZone = requestParameters?.customZone;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairId',
      <any>pairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludePairIds',
      <any>excludePairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/reporting/zero-hash-clob-external-rade`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ReportMetadata>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
